<template>
    <messenger
    :account="account"
    :model="mission"
    v-bind="{data}"
    type="missions"/>
</template>

<script>
import Messenger from "@components/Messenger"
export default {
    props: {
        mission: {
            type: [String, Number],
            default: null
        },

        account: {
            type: [String, Number],
            default: null
        },

        data: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {}
    },

    computed: {},

    components: {Messenger},

    methods: {},

    mounted() {
    },

    watch: {}
}

</script>